export default [
  {
    path: '/cards',
    name: 'cards',
    component: () => import('../../views/cards/cards.vue'),
    meta: {
      pageTitle: 'Cards',
      breadcrumbs: ['Cards'],
    },
    children: [
      /**Editorials**/
      {
        path: 'editorials',
        name: 'card-editorials-list',
        component: () => import('../../views/cards/editorials/list.vue'),
        meta: {
          pageTitle: 'Card Editorials',
          breadcrumbs: ['Cards', 'Editorials'],
        },
      },
      {
        path: 'editorials/create',
        name: 'card-editorials-create',
        component: () => import('../../views/cards/editorials/create.vue'),
        meta: {
          pageTitle: 'Create Card Editorial',
          breadcrumbs: ['Cards', 'Editorials'],
        },
      },
      {
        path: 'editorials/:id/edit',
        name: 'card-editorials-edit',
        component: () => import('../../views/cards/editorials/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Editorial',
          breadcrumbs: ['Cards', 'Editorials'],
        },
      },
      /** End **/

      /** Moments**/
      {
        path: 'moments',
        name: 'card-moments-list',
        component: () => import('../../views/cards/moments/list.vue'),
        meta: {
          pageTitle: 'Card Moments',
          breadcrumbs: ['Cards', 'Moments'],
        },
      },
      {
        path: 'moments/create',
        name: 'card-moments-create',
        component: () => import('../../views/cards/moments/create.vue'),
        meta: {
          pageTitle: 'Create Card Moment',
          breadcrumbs: ['Cards', 'Moments'],
        },
      },
      {
        path: 'moments/:id/edit',
        name: 'card-moments-edit',
        component: () => import('../../views/cards/moments/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Moment',
          breadcrumbs: ['Cards', 'Moments'],
        },
      },
      /** End **/

      /**Playlists**/
      {
        path: 'playlists',
        name: 'card-playlists-list',
        component: () => import('../../views/cards/playlists/list.vue'),
        meta: {
          pageTitle: 'Card Playlists',
          breadcrumbs: ['Cards', 'Playlists'],
        },
      },
      {
        path: 'playlists/create',
        name: 'card-playlists-create',
        component: () => import('../../views/cards/playlists/create.vue'),
        meta: {
          pageTitle: 'Create Card Playlist',
          breadcrumbs: ['Cards', 'Playlists'],
        },
      },
      {
        path: 'playlists/:id/edit',
        name: 'card-playlists-edit',
        component: () => import('../../views/cards/playlists/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Playlist',
          breadcrumbs: ['Cards', 'Playlists'],
        },
      },
      /** End **/

      /** Podcasts **/
      {
        path: 'podcasts',
        name: 'card-podcasts-list',
        component: () => import('../../views/cards/podcasts/list.vue'),
        meta: {
          pageTitle: 'Card Podcasts',
          breadcrumbs: ['Cards', 'Podcasts'],
        },
      },
      {
        path: 'podcasts/create',
        name: 'card-podcasts-create',
        component: () => import('../../views/cards/podcasts/create.vue'),
        meta: {
          pageTitle: 'Create Card Podcast',
          breadcrumbs: ['Cards', 'Podcasts'],
        },
      },
      {
        path: 'podcasts/:id/edit',
        name: 'card-podcasts-edit',
        component: () => import('../../views/cards/podcasts/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Podcast',
          breadcrumbs: ['Cards', 'Podcasts'],
        },
      },
      /** End **/

      /**Podcasts episodes**/
      {
        path: 'podcast-episodes',
        name: 'card-podcast-episodes-list',
        component: () => import('../../views/cards/podcast-episodes/list.vue'),
        meta: {
          pageTitle: 'Card Podcast Episodes',
          breadcrumbs: ['Cards', 'Podcast Episodes'],
        },
      },
      {
        path: 'podcast-episodes/create',
        name: 'card-podcast-episodes-create',
        component: () => import('../../views/cards/podcast-episodes/create.vue'),
        meta: {
          pageTitle: 'Create Card Podcast Episode',
          breadcrumbs: ['Cards', 'Podcast Episodes'],
        },
      },
      {
        path: 'podcast-episodes/:id/edit',
        name: 'card-podcast-episodes-edit',
        component: () => import('../../views/cards/podcast-episodes/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Podcast Episode',
          breadcrumbs: ['Cards', 'Podcast Episodes'],
        },
      },

      /** Weblinks **/
      {
        path: 'weblinks',
        name: 'card-weblinks-list',
        component: () => import('../../views/cards/web-links/list.vue'),
        meta: {
          pageTitle: 'Card Web Links',
          breadcrumbs: ['Cards', 'Web Links'],
        },
      },
      {
        path: 'weblinks/create',
        name: 'card-weblinks-create',
        component: () => import('../../views/cards/web-links/create.vue'),
        meta: {
          pageTitle: 'Create Card Web Link',
          breadcrumbs: ['Cards', 'Web Links'],
        },
      },
      {
        path: 'weblinks/:id/edit',
        name: 'card-weblinks-edit',
        component: () => import('../../views/cards/web-links/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Web Link',
          breadcrumbs: ['Cards', 'Web Links'],
        },
      },
      /**End**/

      /** Stations **/
      {
        path: 'stations',
        name: 'card-stations-list',
        component: () => import('../../views/cards/stations/list.vue'),
        meta: {
          pageTitle: 'Card Stations',
          breadcrumbs: ['Cards', 'Stations'],
        },
      },
      {
        path: 'stations/create',
        name: 'card-stations-create',
        component: () => import('../../views/cards/stations/create.vue'),
        meta: {
          pageTitle: 'Create Card Station',
          breadcrumbs: ['Cards', 'Stations'],
        },
      },
      {
        path: 'stations/:id/edit',
        name: 'card-stations-edit',
        component: () => import('../../views/cards/stations/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Station',
          breadcrumbs: ['Cards', 'Stations'],
        },
      },
      /** End **/

      /** Artists **/
      {
        path: 'artists',
        name: 'card-artists-list',
        component: () => import('../../views/cards/artists/list.vue'),
        meta: {
          pageTitle: 'Card Artists',
          breadcrumbs: ['Cards', 'Artists'],
        },
      },
      {
        path: 'artists/create',
        name: 'card-artists-create',
        component: () => import('../../views/cards/artists/create.vue'),
        meta: {
          pageTitle: 'Create Card Artist',
          breadcrumbs: ['Cards', 'Artists'],
        },
      },
      {
        path: 'artists/:id/edit',
        name: 'card-artists-edit',
        component: () => import('../../views/cards/artists/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Artist',
          breadcrumbs: ['Cards', 'Artists'],
        },
      },
      /** End **/

      /** Livestreams **/
      {
        path: 'livestreams',
        name: 'card-livestreams-list',
        component: () => import('../../views/cards/livestreams/list.vue'),
        meta: {
          pageTitle: 'Card Livestreams',
          breadcrumbs: ['Cards', 'Livestreams'],
        },
      },
      {
        path: 'livestreams/create',
        name: 'card-livestreams-create',
        component: () => import('../../views/cards/livestreams/create.vue'),
        meta: {
          pageTitle: 'Create Card Livestream',
          breadcrumbs: ['Cards', 'Livestreams'],
        },
      },
      {
        path: 'livestreams/:id/edit',
        name: 'card-livestreams-edit',
        component: () => import('../../views/cards/livestreams/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Livestream',
          breadcrumbs: ['Cards', 'Livestreams'],
        },
      },
      /** End **/

      /** Shows **/
      {
        path: 'shows',
        name: 'card-shows-list',
        component: () => import('../../views/cards/shows/list.vue'),
        meta: {
          pageTitle: 'Card Shows',
          breadcrumbs: ['Cards', 'Shows'],
        },
      },
      {
        path: 'shows/create',
        name: 'card-shows-create',
        component: () => import('../../views/cards/shows/create.vue'),
        meta: {
          pageTitle: 'Create Card Show',
          breadcrumbs: ['Cards', 'Shows'],
        },
      },
      {
        path: 'shows/:id/edit',
        name: 'card-shows-edit',
        component: () => import('../../views/cards/shows/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Show',
          breadcrumbs: ['Cards', 'Shows'],
        },
      },
      {
        path: 'shows/:id/edit',
        name: 'card-shows-edit',
        component: () => import('../../views/cards/shows/edit.vue'),
      },
      /** End **/

      /** Show Episodes **/
      {
        path: 'show-episodes',
        name: 'card-show-episodes-list',
        component: () => import('../../views/cards/show-episodes/list.vue'),
        meta: {
          pageTitle: 'Card Show Episodes',
          breadcrumbs: ['Cards', 'Shows'],
        },
      },
      {
        path: 'show-episodes/create',
        name: 'card-show-episodes-create',
        component: () => import('../../views/cards/show-episodes/create.vue'),
        meta: {
          pageTitle: 'Create Card Show Episode',
          breadcrumbs: ['Cards', 'Shows'],
        },
      },
      {
        path: 'show-episodes/:id/edit',
        name: 'card-show-episodes-edit',
        component: () => import('../../views/cards/show-episodes/edit.vue'),
        meta: {
          pageTitle: 'Edit Card Show Episode',
          breadcrumbs: ['Cards', 'Shows'],
        },
      }
      /** End **/
    ]
  }
]
